import type { Activity } from '@/types'
import { ActivityCard } from './ActivityCard'
import { useNow } from '@/hooks/useNow'
import { getActivityStatusMap } from '@/lib/activityStatus'
import { cn } from '@/lib/utils'

interface Props {
  activities: Activity[]
  // Activity ids to render faded. Used by the artist "show all" mode so
  // activities the viewer isn't assigned to read as informational.
  dimmedIds?: Set<string>
}

export function ActivityTimeline({ activities, dimmedIds }: Props) {
  const now = useNow()
  const statusMap = getActivityStatusMap(activities, now)

  // Keep the timeline at mobile-friendly width even on desktop — the extra
  // negative space reads as intentional, not as a narrow mobile view stretched
  // open. Vertical rail + dot + stagger come from the `.timeline` primitive.
  return (
    <div className="timeline max-w-2xl mx-auto">
      {activities.map((activity, index) => (
        <div
          key={activity.id}
          style={{ viewTransitionName: `activity-${activity.id}` }}
          className={cn(
            'transition-opacity dur-base ease-out-soft',
            dimmedIds?.has(activity.id) && 'opacity-50 hover:opacity-80'
          )}
        >
          <ActivityCard
            activity={activity}
            index={index}
            status={statusMap[activity.id]}
            now={now}
          />
        </div>
      ))}
    </div>
  )
}
